import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import Contributor from "../contributor/index";
import { get } from "lodash";
import styles from "./styles.m.css";
import { isPremium } from "../../../data/story";
import { getStoryData, generateImageSources, checkAppSlug } from "../../utils/utils";
import { PremiumBadge } from "../premium-badge";
import hexToRgba from "hex-to-rgba";
// import { Icon } from "../../atoms/icon";

const MagazineBigCard = ({
  story,
  className = "",
  cardWithImageZoom = true,
  hasTruncatedHeadline = true,
  accentColor,
  setmagazineUTM = null
}) => {
  const storyData = getStoryData(story);
  if (!storyData.headline || !story.url) {
    return null;
  }

  let rgba = "";
  if (accentColor) {
    rgba = hexToRgba(accentColor, 0.8);
  }
  const sectionColor = rgba
    ? {
        backgroundColor: rgba,
        boxShadow: "10px 0 0 " + rgba + ", -10px 0 0 " + rgba
      }
    : {};

  const contributorName = get(story, ["authors", 0, "name"], "");
  const contributorRole = get(story, ["authors", 0, "contributor-role", "name"], "");
  const externalLink = get(story, ["metadata", "reference-url"]);
  const checkSlug = checkAppSlug();
  let SourceLink = "";

  const duration = get(story, ["metadata", "story-attributes", "audiolength"], 0);

  const minutes = Math.floor(duration / 60);

  const formatTime = time => {
    if (isNaN(time)) return "";
    const mins = Math.floor(time / 60);
    return `${mins} Min${mins === 1 ? "" : "s"}`;
  };

  const cardurlslug = externalLink || story.url;

  const params = new URLSearchParams();
  if (setmagazineUTM) {
    params.set("utm_source", setmagazineUTM);
  }
  params.set("play", "true");

  let seturlslug = setmagazineUTM ? `${cardurlslug}?utm_source=${setmagazineUTM}` : cardurlslug;

  let setlistenurlslug = `${cardurlslug}?${params.toString()}`;

  if (checkSlug) {
    SourceLink = externalLink || story.url;
  }

  return (
    <div className={`${styles.base} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}>
      <div className={styles["story-wrapper"]}>
        <Link
          aria-label={`${"Read full story: "} ${storyData.headline}`}
          href={seturlslug}
          externalLink={SourceLink || externalLink}
          className={styles["story-wrapper-image"]}
        >
          <ResponsiveImageWithFallback
            className={styles["slider-image-wrapper"]}
            slug={storyData.imageS3Key}
            metadata={storyData.imageMetadata}
            alt={storyData.imageCaption}
            imgParams={{ auto: ["format", "compress"] }}
            sources={generateImageSources(
              { aspectRatio: [1, 1], screenWidthCoverage: 0.7 },
              { aspectRatio: [1, 1], screenWidthCoverage: 0.6 }
            )}
          />
          <PremiumBadge isPremium={isPremium(story)} />
        </Link>
        <div className={styles["text-wrapper"]}>
          <Link
            aria-label={`${"Read full story: "} ${storyData.headline}`}
            href={externalLink || story.url}
            externalLink={SourceLink || externalLink}
            className={styles["flex-headline"]}
          >
            <h3 className={`${styles["headline"]} ${hasTruncatedHeadline ? styles["truncated"] : ""} `}>
              <span style={sectionColor} className={styles.highlight}>
                {storyData.headline}
              </span>
            </h3>
            <p className={`${styles.content} ${hasTruncatedHeadline ? styles["truncated"] : ""}`}>
              {story.subheadline}
            </p>
          </Link>

          <div className={styles["contributor-listen-wrapper"]}>
            {contributorName && (
              <Contributor name={contributorName} type={contributorRole} className={styles["contributor"]} />
            )}
            {minutes > 0 && (
              <Link
                aria-label={`${"Read full story: "} ${storyData.headline}`}
                href={setlistenurlslug}
                externalLink={SourceLink || externalLink}
                className={styles["flex-headline"]}
              >
                <div className={styles["listen-now"]}>
                  <img src="https://media.vikatan.com/vikatan/2025-09-08/gf551pnp/icon-headset.png" alt="Listen" />
                  <span className={styles["listen-now-text"]}>
                    {" "}
                    Listen <i className={styles["readtime"]}>{formatTime(duration)}</i>
                  </span>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

MagazineBigCard.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  hasTruncatedHeadline: PropTypes.bool,
  className: PropTypes.string,
  setmagazineUTM: PropTypes.string,
  accentColor: PropTypes.string,
  story: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    subheadline: PropTypes.string,
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        "display-name": PropTypes.string,
        color: PropTypes.string
      })
    ),
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  })
};

export default MagazineBigCard;
